<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="primary" >
      <b-navbar-brand href="#">
        <div class="d-flex">
          <div @click="resetForm"  class="navbar-brand-full d-none d-md-block ministry-logo">
            <img :src="logoUrl" alt="unicef">
          </div>

          <div class="logo-unicef-public">
            <img class="navbar-brand-full  d-md-block"  src="img/logo/logo_unicef.png" alt="unicef">
          </div>

        </div>

      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <router-link class="router-link-exact-active nav-link" :to="{name: routeNames.RN_LOGIN}">
            {{$t('LOGIN')}}
          </router-link>

          <b-nav-item-dropdown  :text="$t('LANGUAGE')" right>
            <b-dropdown-item @click="selectLanguage('bs')">{{$t('BA')}}</b-dropdown-item>
            <b-dropdown-item @click="selectLanguage('hr')">{{$t('HR')}}</b-dropdown-item>
            <b-dropdown-item @click="selectLanguage('sr')">{{$t('SR')}}</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-card>
      <app-aside :widths="['col-sm-12', '40%']" v-model="editAside">
        <template slot="header">Pregled</template>
        <br/>
        <RecommendationLanguageWrapper :onlyRead="true" :header="editObject"/>
      </app-aside>
      <form class="mb-4" @submit.prevent="search(1)" @reset.prevent="resetForm">
        <b-row>
          <b-col md="3">
            <label class="label-text">{{$t('DOMAIN')}}</label>
            <multiselect
              placeholder="-"
              :selectedLabel="$t('SELECTED')"
              :selectLabel="$t('APPLY')"
              :deselectLabel="$t('CLEAR')"
              v-model="filter.domain" :options="domains" label="name" track-by="id"/>
          </b-col>
          <b-col md="2">
            <label class="label-text">{{$t('COMPLETION_STATUS')}}</label>
            <multiselect
              placeholder="-"
              :selectedLabel="$t('SELECTED')"
              :selectLabel="$t('APPLY')"
              :deselectLabel="$t('CLEAR')"
              v-model="filter.status_complete" :options="statusOptions" label="name" track-by="id"/>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col class="d-inline-flex">
            <app-submit :disabled="loading" :loading="loader_submit" class="mr-3" variant="primary"  button_type="search"> {{$t('SEARCH')}}</app-submit>
            <app-submit :disabled="loading" :loading="loader_reset" class="mr-3" variant="outline-primary" type="reset" button_type="reset">{{$t('RESET')}}</app-submit>
          </b-col>
        </b-row>
      </form>
      <div class="position-relative">
        <div v-if="items && items.length > 0" class="table-container">
          <b-table class="applicant_table animated fadeIn" responsive hover :fields="fields" :items="items"
                   primary-key="id" :busy="loading">
            <template v-slot:cell(domain.name)="data">
              <b>{{data.item.domain.name}}</b>
            </template>
            <template v-slot:cell(num)="data">
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </template>
            <template v-slot:cell(indicator)="data">
              <div v-html="data.item.indicator"></div>
            </template>
            <template v-slot:cell(recommendation)="data">
              <div v-html="data.item.recommendation"></div>
            </template>
            <template v-slot:cell(goal)="data">
              <div v-html="data.item.goal"></div>
            </template>
            <template v-slot:cell(competent_organ)="data">
            <span v-for="(competentAuthority, index) in data.item.competent_authorities">
               {{competentAuthority.name}}<span v-if="
              showComa(data.item.competent_authorities, index)">,</span>
            </span>
            </template>
            <template v-slot:cell(edit)="data">
              <app-button class="pull-right"
                          @click="edit(data.item)"
                          size="sm"
                          variant="link">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </app-button>
            </template>
            <template v-slot:cell(action)="data">
              <button
                class="btn-detail"
                size="sm"
                type="button"
                @click="showData(data.item)"
              >
                {{$t('DETAIL')}}
              </button>
            </template>
            <template v-slot:cell(status)="data">
              <AppIndicator v-b-tooltip.hover :title="indicatorTooltip(data.item.status_complete)" :indicator_type="indicatorType(data.item.status_complete)"/>
            </template>
          </b-table>
          <b-pagination
            size="sm"
            :prev-text="$t('PREV')"
            :next-text="$t('NEXT')"
            :total-rows="total"
            :per-page="perPage"
            v-model="currentPage">
          </b-pagination>
        </div>
      </div>
    </b-card>
  </div>

</template>

<script>
import AppAside from '@/components/app/form/AppAside.vue'
import AppButton from "@/components/app/AppButton.vue";
import routeNames from '@/router/routeNames'
import {formatDate, formatDecimals, formatDateTime} from '@/filters/formatDates';
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {getRecommendationList} from "@/services/public";
import AppIndicator from "@/components/app/AppIndicator.vue";
import RecommendationForm from "@/components/recommendation/RecommendationForm.vue";
import RecommendationLanguageWrapper from "@/components/recommendation/RecommendationLanguageWrapper.vue";
import {mapGetters} from "vuex";
import {app} from "@/main";
import Multiselect from "vue-multiselect";
import AppSubmit from "@/components/app/AppSubmit.vue";

export default {
  name: "index",
  mixins: [getErrorMessage],
  data() {
    return {
      filter: {
        domain: null,
        status_complete: null
      },
      editAsidePanelState: false,
      currentPage: 1,
      listCount: 100,
      perPage: 5,
      total: 0,
      loading: false,
      routeNames,
      editAside: false,
      items: [],
      editObject: null,
      loader_submit: false,
      loader_reset: false,
      language: 'bs',
      statusOptions: [
        {id: 1, name: this.$t('NOT_FULFILLED')},
        {id: 2, name: this.$t('PARTIALLY_FULFILLED')},
        {id: 3, name: this.$t('FILLED')},
      ],
    }
  },
  components: {
    AppSubmit, Multiselect,
    RecommendationLanguageWrapper,
    RecommendationForm,
    AppIndicator,
    AppAside,
    AppButton,
  },
  filters: {
    formatDate,
    formatDateTime,
    formatDecimals
  },
  computed: {
    ...mapGetters('user', ['currentLanguage']),
    ...mapGetters('competentAuthority', ['competentAuthorities']),
    ...mapGetters('recommendation', ['domains']),
    logoUrl() {
      return this.language === 'sr' ? 'img/logo/javni-cirilica.png' : 'img/logo/javni-latinica.png';
    },
    fields() {
      return  [
        {key: 'num', label: 'Rb',  tdClass: 'top-align'},
        {key: 'domain.name', label: this.$t('DOMAIN'), tdStyle: { verticalAlign: "top" }, tdClass: 'top-align'},
        {key: 'recommendation', label: this.$t('RECOMMENDATIONS'),  thStyle: { width: "22%" }},
        {key: 'competent_organ', label: this.$t('COMPETENT_ORGAN'), thStyle: { width: "12%" }, tdClass: 'top-align'},
        {key: 'indicator', label: this.$t('INDICATOR')},
        {key: 'goal', label: this.$t('GOAL'), tdClass: 'top-align'},
        {key: 'status', label: ''},
        {key: 'action', label: ''},
      ];
    },
  },
  methods: {
    showComa(competent_authorities, index){
      return competent_authorities.length > 1 && index !== (competent_authorities.length - 1)
    },
    indicatorTooltip(status) {
      const indicatorObject = this.statusOptions.find((el) => el.id === status);
      if(indicatorObject && indicatorObject.name) {
        return indicatorObject.name
      }
      return  null
    },
    resetForm() {
        this.filter.domain = null;
        this.filter.status_complete = null;
        this.perPage = 5;
        this.currentPage = 1;
        this.search();
    },
    selectLanguage(lang) {
      this.language = lang;
      app.$i18n.locale = lang;
      localStorage.setItem('language', lang);
    },
    indicatorType(status){
      if(status === 1) {
        return 'indicator-danger'
      }
      if(status === 2) {
        return 'indicator-warning';
      }
      if(status === 3) {
        return 'indicator-success'
      }
    },
    showData(item) {
      this.editAside = true;
      this.editObject = item;
    },
    search(currentPage) {
      this.loading = true;
      const request = {
        domain: this.filter.domain ? this.filter.domain.id : null,
        status_complete: this.filter.status_complete ? this.filter.status_complete.id : null,
        limit: 5,
        page: currentPage ? currentPage : this.currentPage,
      }
      getRecommendationList(request).then((response) => {
        this.items = response.data.items
        this.total = response.data.total
        this.currentPage = response.data.page
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loading = false
      })
    },

  },
  watch: {
    currentPage: {
     async handler(value) {
        await this.search(value);
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200)

      }
    },
/*    language: {
      handler(value) {
        this.search(value);
      }
    }*/
  },
  async mounted() {
    this.language = localStorage.getItem('language') ? localStorage.getItem('language') : 'bs';
    if (!(this.domains && this.domains.length > 0)) {
      await this.$store.dispatch('recommendation/actionSetDomains')
    }

    if (!(this.competentAuthorities && this.competentAuthorities.length > 0)) {
      await this.$store.dispatch('competentAuthority/actionSetCompetentAuthorities')
    }
    this.search();
  }
}
</script>

<style scoped>
.navbar-dark .navbar-nav .nav-link {
  color: white;
}

.btn-detail {
  background-color: #63c2de;
  color: white;
  border: none;
  border-radius: 4px;
  padding-bottom: 2px;
  padding-top: 2px;
}

.btn-detail:focus {
  outline: none;
}
.ministry-logo {
  align-self: center;
  height: 50px;
}
.navbar {
  padding: 0 1rem;
}
.navbar-brand {
  padding-bottom: 0;
  padding-top: 0;
}
@media (max-width: 991.98px) {
  .navbar-brand {
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
  }
}

</style>
